import React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { enCurrency, enLang } from 'interfaces/IProductData';
import { currencyService } from 'services/CurrencyService';
import Menu from '@material-ui/core/Menu/Menu';
import CurrencyItem from './CurrencyItem';

const styles = require('./configCurrency.css');

interface IState extends IStateBase {
  anchorEl: any;
  options: { lang: enLang, currency: enCurrency, symbol: string }[];
  currency: enCurrency;
}

export default class ConfigCurrency extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      anchorEl: null,
      options: [
        { lang: enLang.PT_BR, currency: enCurrency.BRL, symbol: 'R$' },
        { lang: enLang.EN_US, currency: enCurrency.USD, symbol: '$' }
      ],
      currency: null
    };
  }

  componentDidMount() {
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  close = () => {
    this.setState({ anchorEl: null });
  }

  open = (event: any) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  selectCurrency = (currency: enCurrency) => {
    currencyService.setCurrency(currency);
    this.close();
  }

  render() {

    const { anchorEl, options, currency } = this.state;

    if (!currency) {
      return <div />;
    }

    return (
      <div className={'chk-config-currency ' + styles.component} id='chk-config-currency'>
        <Menu
          id='lock-menu'
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.close}
          className='chk-configCurrency__menu'
        >
          {options.map((option) => (
            <CurrencyItem
              key={option.currency}
              option={option}
              selected={currency === option.currency}
              onSelect={this.selectCurrency}
            />
          ))}
        </Menu>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/ConfigCurrency/index.tsx